"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withDefaults = _interopRequireDefault(require("../utils/with-defaults"));

var _icon = _interopRequireDefault(require("./icon"));

var _link = _interopRequireDefault(require("./link.styles"));

var _assertion = require("../utils/assertion");

var _jsxRuntime = require("react/jsx-runtime");

const defaultProps = {
  icon: false
};

const Link = /*#__PURE__*/_react.default.forwardRef(({
  children,
  icon,
  ...props
}, forwardedRef) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_link.default, { ...props,
  ref: forwardedRef,
  children: [children, icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {})]
}));

if (_assertion.__DEV__) {
  Link.displayName = 'NextUI - Link';
}

Link.toString = () => '.nextui-link';

var _default = (0, _withDefaults.default)(Link, defaultProps);

exports.default = _default;
module.exports = exports.default;